import { Component, Prop } from 'vue-property-decorator';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';

@Component({
  name: 'bpc-display-field-booking-event-select',
  components: {},
})
export default class DisplayFieldBookingEventSelect extends mixins(AbstractDisplayField) {
  @Prop({
    type: [Array],
    default() {
      return [];
    },
  })
  readonly fixedOptions: object[];
  translatedOptions() {
    let options = [];
    if (this.fixedOptions.length > 0) {
      options = this.fixedOptions;
    } else {
      this.fieldConfig.options.forEach(option => {
        if (
          (option['value'] === 'create' && !this.item['conflicts'].length) ||
          option['value'] === 'nothing' ||
          (option['value'] === 'overwrite' && this.item['conflicts'].length)
        ) {
          const newOption = {};
          newOption['label'] = this.$t(option['label']);
          newOption['value'] = option['value'];
          options.push(newOption);
        }
      });
    }
    return options;
  }

  get selectClass(): string {
    const color = this.fieldConfig.options?.find(option => option.value === this.item.action)
      ?.color;
    return color ? `${color}` : '';
  }
}
